import React from 'react';

const AvgFloodingComparisonTable = ({ selectedFeature, compareAvgFloodRes, tableHeaderStyle, tableCellStyle }) => {
    if (!selectedFeature || !selectedFeature.ID) {
        return (
            <div style={{ textAlign: 'center', marginTop: '20px', marginBottom: '20px', padding: '20px', border: '1px solid #2196F3', borderRadius: '8px', backgroundColor: '#121212' }}>
                <p style={{ color: '#FFFFFF', fontSize: '16px' }}>
                    Select a subcatchment to view the before and after values of average flooding.
                </p>
            </div>
        );
    }

    const geojsonData = Array.from(compareAvgFloodRes)[0];
    let featureData = null;

    if (geojsonData && geojsonData.features) {
        featureData = geojsonData.features.find(f => f.properties.NAME === selectedFeature.ID);
    }

    if (!featureData) {
        return (
            <div style={{ textAlign: 'center', marginTop: '20px', marginBottom: '20px', padding: '20px', border: '1px solid #2196F3', borderRadius: '8px', backgroundColor: '#121212' }}>
                <p style={{ color: '#FFFFFF', fontSize: '16px' }}>
                    Data for the selected subcatchment is not available in the comparison results.
                </p>
            </div>
        );
    }

    const { avgFlooding, avgFlooding_1, avgFlooding_2 } = featureData.properties;

    const formatValue = (value) => (value !== undefined && value !== null ? value.toFixed(3) : 'N/A');

    return (
        <div style={{ marginTop: '20px', marginBottom: '32px', width: '90%' }}>
            <h3 style={{ color: '#2196F3', textAlign: 'center' }}>Average Flooding Details for Subcatchment: {selectedFeature.ID}</h3>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                    <tr>
                        <th style={tableHeaderStyle}>Metric</th>
                        <th style={tableHeaderStyle}>Value</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td style={tableCellStyle}>Average Flooding Difference (Plan 2 - Plan 1)</td>
                        <td style={tableCellStyle}>{formatValue(avgFlooding)}</td>
                    </tr>
                    <tr>
                        <td style={tableCellStyle}>Average Flooding (Plan 1)</td>
                        <td style={tableCellStyle}>{formatValue(avgFlooding_1)}</td>
                    </tr>
                    <tr>
                        <td style={tableCellStyle}>Average Flooding (Plan 2)</td>
                        <td style={tableCellStyle}>{formatValue(avgFlooding_2)}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
};

export default AvgFloodingComparisonTable; 